<template>
  <div
    ref="frisbuy-widget-gallery"
    :class="{ 'frisbuy-widget': true, 'frisbuy-class': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, [`frisbuy-${ settings.customerCode }`]:true}"
    :style="[galleryStyle]"
  >
    <!-- <script
      src="https://connect.facebook.net/en_US/all.js"
      async=""
      type="application/javascript"
      v-if="settings.popup.shareButtons.fb"
    ></script> -->
    <div class="frisbuy-header">
      <div
        class="frisbuy-title"
        v-if="headerSettings.title || headerSettings.buttonTitle"
      >
        {{headerSettings.title}}<a
          v-if="headerSettings.buttonTitle"
          :href="headerSettings.buttonLink"
          >{{headerSettings.buttonTitle}}</a
        >
      </div>
      <div
        v-if="headerSettings.subTitle"
        class="frisbuy-subtitle"
        :style="[subTitleStyle]"
      >
        {{headerSettings.subTitle}}
      </div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{ 'frisbuy-category': true, 'frisbuy-active': filterValue == filter.value || (filterValue == null && !filter.value) }"
        v-for="filter in gallerySettings.filters.params"
        @click="chosenFilter(filter)"
        >{{filter.name}}</a
      >
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{ 'frisbuy-scroll-wrapper': true, 'no-scroll-width': !isVerticalGallery && scrollWidth < 0 }"
        :style="{ height: isVerticalGallery && gallerySettings.maxCols && `${ ((containerItemHeight + containerItemMargin) * gallerySettings.maxCols) }px`}"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
        @mousedown.stop="handleMouseDownScroll"
        @mouseleave.stop="handleMouseLeaveScroll"
        @mouseup.stop="handleMouseUpScroll"
        @mousemove.stop="handleMouseMoveScroll"
      >
        <div
          :style="{ padding: isLineRowsMode && scrollWidth < 0 && `0 ${ containerItemMargin / 2}px` }"
        >
          <ul
            :class="{ 'frisbuy-gallery-posts': true, 'frisbuy-gallery-multiline': isLineRowsMode, [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme }"
            :style="{ margin: `-${ containerItemMargin / 2}px`, width: `calc(100% + ${ containerItemMargin }px)`, maxHeight: !isVerticalGallery && isLineRowsMode && containerRowsHeight }"
          >
            <template v-for="(post, index) in postList">
              <li
                v-if="gallerySettings.scheme && !isTablet && (index == 5 || !((index - 5) % 9))"
                class="frisbuy-divider"
              ></li>
              <template v-if="post.frisbuyPost.type === 'advertising'"></template>
              <post-item
                v-else
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{width: getPostItemWidth(index), margin: `${ containerItemMargin / 2 }px` }"
                :observer="imageObserver"
                @click.native="handleClickPost(post, index)"
              >
              </post-item>
            </template>
          </ul>
        </div>
      </div>
      <div
        v-if="gallerySettings.layout == 'arrow' && ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)"
        :class="{ 'frisbuy-gallery-navigation': true, 'frisbuy-big': isLineRowsMode }"
      >
        <div
          :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canPrevScroll}"
          @click="slideHandler(-1)"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 24 32"
            xml:space="preserve"
          >
            <polyline
              stroke="currentColor"
              fill="none"
              points="16,24 8,16 16,8"
            />
          </svg>
        </div>
        <span></span>
        <div
          :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canNextScroll}"
          @click="slideHandler(1)"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 24 32"
            xml:space="preserve"
          >
            <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24" />
          </svg>
        </div>
      </div>
    </div>
    <div
      v-if="gallerySettings.branding"
      :class="[{'frisbuy-branding': true}, gallerySettings.branding ]"
    >
      Сделано на
      <a
        :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)"
        rel="nofollow"
        target="_blank"
      >
        <img
          :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`"
          alt="Frisbuy"
        />
      </a>
    </div>
    <div class="frisbuy-footer">
      <div
        :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px'}"
        class="frisbuy-loadmore-button"
        v-if="gallerySettings.layout == 'tile' && gallerySettings.loadMore.enable && gallerySettings.loadMore.show"
        @click="loadMoreHandler"
      >
        {{ gallerySettings.loadMore.text || 'Ещё' }}
      </div>
      <div
        v-if="gallerySettings.footer.html"
        v-html="gallerySettings.footer.html"
      ></div>
    </div>
    <div
      v-if="gallerySettings.guideline.html && isGuidlineOpen"
      class="frisbuy-guideline"
    >
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";

export default {
  mixins: [defaultGallery],

  data() {
    return {
      isMouseDown: false,
      dragScrollLeft: null,
      startX: null,
      isDragging: false,
    };
  },

  methods: {
    handleMouseDownScroll(event) {
      const { postsScroll } = this.$refs;
      this.isMouseDown = true;
      postsScroll.classList.add("active-grab-scroll");
      this.startX = event.pageX - postsScroll.offsetLeft;
      this.dragScrollLeft = postsScroll.scrollLeft;
    },

    handleArrowScrollClick(direction) {
      const { postImage } = this.$refs;
      const widthElement = this.widgetRefElement.querySelector(".frisbuy-gallery-posts");
      const colsNumber = parseInt(this.gallerySettings.maxCols);
      const scrollWidth =
        (postImage[0].$el.clientWidth + this.containerItemMargin) * colsNumber;
      this.slideHandler((scrollWidth / widthElement.clientWidth) * direction);
    },

    handleMouseLeaveScroll() {
      this.isMouseDown = false;
      setTimeout(() => (this.isDragging = false), 0);
      this.$refs.postsScroll.classList.remove("active-grab-scroll");
    },

    handleMouseUpScroll() {
      this.isMouseDown = false;
      setTimeout(() => (this.isDragging = false), 0);
      this.$refs.postsScroll.classList.remove("active-grab-scroll");
    },

    handleMouseMoveScroll(event) {
      if (!this.isMouseDown) return;
      event.preventDefault();
      const { postsScroll } = this.$refs;
      const initialScrollLeft = postsScroll.scrollLeft;
      const pageX = event.pageX - postsScroll.offsetLeft;
      const walk = (pageX - this.startX) * 2;
      postsScroll.scrollLeft = this.dragScrollLeft - walk;
      if (initialScrollLeft !== postsScroll.scrollLeft) {
        this.isDragging = true;
      }
    },

    handleClickPost(post, index) {
      const { isMouseDown, isDragging } = this;
      if (isMouseDown || isDragging) return;
      this.clickPostHandler(post, index);
    },
  },
}
</script>
